"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonConfigValue = void 0;
var env_1 = require("./env");
var constants_1 = require("../constants");
var resolveCommonConfig = function () {
    return env_1.getGlobal(function (g) { return (g.Wix && g.Wix.Utils && g.Wix.Utils.commonConfig) || g.commonConfig; });
};
exports.getCommonConfigValue = function (key, commonConfig) {
    if (commonConfig === void 0) { commonConfig = resolveCommonConfig(); }
    commonConfig =
        commonConfig && typeof commonConfig.getAll === 'function'
            ? commonConfig.getAll()
            : commonConfig;
    if (!commonConfig || typeof commonConfig[key] === 'undefined') {
        return constants_1.DefaultCommonConfig[key];
    }
    return commonConfig[key];
};
//# sourceMappingURL=common-config.js.map